import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'login-container',
	template: require('./login-container.component.html'),
})
export class LoginContainerComponent {
	public isNewLoginEnabled: boolean = AppSettings.isHybridLoginEnabled;
}
